import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { SystemNotification } from '../../models/system-notification.model';

/**
 * Service for retrieving system notifications.
 * Located in services/notification instead of services/api because it handles
 * public notifications that don't require authentication, unlike other API services.
 */
@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private readonly apiUrl = `${environment.apiUrl}/notifications/system`;

  constructor(private http: HttpClient) { }

  getSystemNotifications(): Observable<SystemNotification[]> {
    return this.http.get<SystemNotification[]>(this.apiUrl).pipe(
      catchError((error) => {
        console.error('Error fetching system notifications:', error);
        return of([]); // Return empty array on error
      })
    );
  }
}
